<script setup>
import { onMounted, ref } from "vue";
import Menu from 'primevue/menu';
import { useAuthStore } from "@/stores/authStore";
import ManualOrderPopup from "../Popups/ManualOrderPopup.vue";
import StoreCreditPopup from "../Popups/StoreCreditPopup.vue";
import CheckInventoryPopup from "../Popups/CheckInventoryPopup.vue";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

const authStore = useAuthStore();

const menu = ref();
const items = ref([
    {
        // label: 'Actions',
        // class: 'menu-header',
        items: [
            {
                label: 'Refund',
                icon: 'pi pi-refresh',
                class: 'menu-item',
                command: () => {
                    authStore.toggleRefundPopup();
                }
            },
            {
                label: 'Manual Order',
                icon: 'pi pi-download',
                class: 'menu-item',
                command: () => {
                    authStore.toggleManualOrderPopup();
                }
            }
        ]
    }
]);

const toggle = (event) => {
    menu.value.toggle(event);
};
onMounted(() => {
    tippy('.menu-container', {
        content: 'Actions',
        animation: 'scale',
        // placement: 'bottom',
    });
});
</script>

<template>
    <div class="menu-container">
        <Button
            :disabled="!(authStore.isUserLoggedIn || authStore.isManagerLoggedIn)"
            :class="{ 'opacity-50 cursor-not-allowed': !(authStore.isUserLoggedIn || authStore.isManagerLoggedIn) }"
            class="menu-button"
            type="button" 
            @click="toggle" 
            aria-haspopup="true" 
            aria-controls="overlay_menu"
            text
            rounded
        >
            <img src="/menu.svg" alt="Menu" class="menu-icon">
        </Button>
        <Menu 
            ref="menu" 
            id="overlay_menu" 
            :model="items" 
            :popup="true"
        />
    </div>
    <ManualOrderPopup v-if="authStore.isManualOrderPopupVisible && (authStore.isUserLoggedIn || authStore.isManagerLoggedIn)" />
    <StoreCreditPopup v-if="authStore.isRefundPopupVisible && (authStore.isUserLoggedIn || authStore.isManagerLoggedIn)" />
</template>

<style scoped>
.menu-container {
    position: relative;
}

.menu-button {
    padding: 0.5rem;
    transition: background-color 0.2s;
}

.menu-button:hover {
    background-color: var(--primary-color-light);
}

.menu-icon {
    width: 1.5rem;
    height: 1.5rem;
}
</style>

<style>
.p-menu {
    --p-menu-background: #ffffff;
    --p-menu-border-radius: 0.5rem;
    --p-menu-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --p-menu-list-padding: 0.5rem;
    --p-menu-list-gap: 0.25rem;
    --p-menu-item-padding: 0.75rem 1rem;
    --p-menu-item-border-radius: 0.375rem;
    --p-menu-item-gap: 0.75rem;
    --p-menu-item-icon-color: var(--primary-color);
    --p-menu-separator-border-color: #e5e7eb;
    width: 14rem;
}

.p-menu .menu-header {
    font-weight: 600;
    color: var(--text-color-secondary);
    padding: 0.75rem 1rem;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.05em;
}

.p-menu .menu-item .p-menuitem-link {
    transition: all 0.2s ease;
}

.p-menu .menu-item .p-menuitem-link:hover {
    background-color: var(--p-menu-item-focus-background, #f3f4f6);
    color: var(--p-menu-item-focus-color, inherit);
}

.p-menu .menu-item .p-menuitem-link:hover .pi {
    color: var(--p-menu-item-icon-focus-color, var(--primary-color));
}
</style>